import { cn } from "../../utils/classNames"

interface SpinnerProps {
  size?: "sm" | "md" | "lg" | "xl"
  className?: string
}

export const Spinner = ({ size = "md", className }: SpinnerProps) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-6 w-6 md:h-8 md:w-8",
    lg: "h-10 w-10 md:h-12 md:w-12",
    xl: "h-12 w-12 md:h-16 md:w-16",
  }

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div className="relative">
        <div
          className={cn(
            "animate-spin rounded-full border-2 md:border-4 border-theme_accent_light",
            sizeClasses[size]
          )}
          style={{
            borderTopColor: "var(--theme_accent)",
            borderRightColor: "var(--theme_accent)",
          }}
        />
        <div
          className={cn(
            "absolute inset-0 animate-pulse rounded-full",
            sizeClasses[size]
          )}
          style={{
            background: `radial-gradient(circle, transparent, transparent 40%, var(--theme_accent_light) 50%, transparent 60%)`,
          }}
        />
      </div>
    </div>
  )
}

export const SpinnerPage = () => {
  return (
    <div className="flex min-h-[300px] md:min-h-[400px] w-full items-center justify-center p-4">
      <div className="mb-20 md:mb-0">
        <Spinner size="lg" />
      </div>
    </div>
  )
}